// extracted by mini-css-extract-plugin
export default {"links":"Administrator_links__CzYyp"};